import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router'
import './autoki-speak.css'

const AutokiSpeak = (props) => {
    const history = useHistory()
    const [textInput, setTextInput] = useState('')
    const [isSpeaking, setIsSpeaking] = useState(false)
    const [speakHistory, setSpeakHistory] = useState([])

    useEffect(() => {
        // Load previous speak history from sessionStorage
        const history = sessionStorage.getItem('autokiSpeakHistory')
        if (history) {
            setSpeakHistory(JSON.parse(history))
        }
    }, [])

    const handleBack = () => {
        history.push('/appMode/selectHardware')
    }

    const handleSpeak = () => {
        if (!textInput.trim()) {
            alert('Please enter text to speak')
            return
        }

        setIsSpeaking(true)

        // Send text to device via WebSerial
        // Example: sendCommand(`SPEAK:${textInput}`)

        // Add to history
        const newHistory = [
            ...speakHistory,
            {
                text: textInput,
                timestamp: new Date().toLocaleTimeString(),
            },
        ]
        setSpeakHistory(newHistory.slice(-10)) // Keep last 10
        sessionStorage.setItem(
            'autokiSpeakHistory',
            JSON.stringify(newHistory.slice(-10))
        )

        // Use browser TTS
        const utterance = new SpeechSynthesisUtterance(textInput)
        utterance.rate = 1.0
        utterance.pitch = 1.0
        utterance.volume = 1.0
        utterance.onend = () => {
            setIsSpeaking(false)
        }
        window.speechSynthesis.speak(utterance)
    }

    const handleStop = () => {
        window.speechSynthesis.cancel()
        setIsSpeaking(false)
    }

    const handleClearHistory = () => {
        setSpeakHistory([])
        sessionStorage.removeItem('autokiSpeakHistory')
    }

    const handleSpeakFromHistory = (text) => {
        setTextInput(text)
    }

    return (
        <div className="autoki-speak-container">
            <div className="speak-header">
                <h1>Autoki Speech Control</h1>
                <button onClick={handleBack} className="back-btn">
                    ← Back
                </button>
            </div>

            <div className="speak-content">
                <div className="input-section">
                    <h2>Enter Text to Speak</h2>
                    <textarea
                        className="text-input"
                        value={textInput}
                        onChange={(e) => setTextInput(e.target.value)}
                        placeholder="Type something here..."
                        disabled={isSpeaking}
                        rows="6"
                    />

                    <div className="button-group">
                        <button
                            onClick={handleSpeak}
                            className="speak-btn"
                            disabled={isSpeaking}
                        >
                            🔊 Speak
                        </button>
                        {isSpeaking && (
                            <button onClick={handleStop} className="stop-btn">
                                ⏹️ Stop
                            </button>
                        )}
                    </div>

                    <div className="status">
                        {isSpeaking ? (
                            <p className="speaking">🎤 Speaking...</p>
                        ) : (
                            <p className="ready">Ready to speak</p>
                        )}
                    </div>
                </div>

                <div className="history-section">
                    <div className="history-header">
                        <h3>Speech History</h3>
                        {speakHistory.length > 0 && (
                            <button
                                onClick={handleClearHistory}
                                className="clear-btn"
                            >
                                Clear
                            </button>
                        )}
                    </div>

                    <div className="history-list">
                        {speakHistory.length === 0 ? (
                            <p className="empty-message">
                                No speech history yet
                            </p>
                        ) : (
                            speakHistory.map((item, index) => (
                                <div key={index} className="history-item">
                                    <div className="history-text">
                                        {item.text}
                                    </div>
                                    <div className="history-time">
                                        {item.timestamp}
                                    </div>
                                    <button
                                        onClick={() =>
                                            handleSpeakFromHistory(item.text)
                                        }
                                        className="replay-btn"
                                    >
                                        🔄 Use
                                    </button>
                                </div>
                            ))
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AutokiSpeak
